import { useEffect, useState } from 'react';
import useThrowAsyncError from '../../../hooks/useThrowAsyncError';
import { fetchMethods, Method } from '../api/methodsApi';

function useMethods(id?: string) {
  const handleError = useThrowAsyncError();

  const [methods, setMethods] = useState<Method[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!id) return;

    setLoading(true);

    async function getMethods(): Promise<void> {
      try {
        const methods = await fetchMethods([id!]);
        setMethods(methods);
      } catch (e) {
        handleError(e);
      } finally {
        setLoading(false);
      }
    }

    getMethods();
  }, [handleError, id]);

  function resetMethods() {
    setMethods([]);
  }

  return { methods, loading, resetMethods };
}

export default useMethods;
